import {Box, Typography} from '@mui/material';
import {accauntSettingsStyle} from './AccountSettings.styles';
import {ReactComponent as ArrowRightIcon} from '@icons/arrow-right.svg';
import {ReactComponent as ImportIcon} from '@icons/import-file.svg';
import {ReactComponent as TicketIcon} from '@icons/sidebar/ticket.svg';
import {ReactComponent as MoneyIcon} from '@icons/sidebar/money.svg';
import {ReactComponent as WarningIcon} from '@icons/danger.svg';
import {useNavigate} from 'react-router-dom';
import {orgStorage} from '@/utils/services';
import {ROUTER_URL} from '@/utils/enums';
import {useAppDispatch} from '@/store/hooks';
import {clearEventData} from '@/store/organization-event';
import {organizationLogout} from '@/store/organization';
import Modal from '@/shared/components/Modal';
import {useState} from 'react';
import ConfirmationModal from '../General/ChangePasswordModal';
import {setNotifications} from '@/store/notification';
import { useApiInstance } from '@/contexts/ApiInstanceContext';

const AccountSettings = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const {apiInstance} = useApiInstance();

  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);
  const [isShowChangePasswordModal, setIsShowChangePasswordModal] = useState(false);

  const handleBillingClick = () => {
    orgStorage.set('activeTab', 'Billing');
    navigate(ROUTER_URL.ORGANIZATION_PROFILE_BILLING);
  };

  const handleProfileClick = () => {
    orgStorage.set('activeTab', 'Profile');
    navigate(ROUTER_URL.ORGANIZATION_PROFILE);
  };
  const handleNotificationClick = () => {
    orgStorage.set('activeTab', 'Notifications');
    navigate(ROUTER_URL.ORGANIZATION_PROFILE_NOTIFICATION);
  };

  const handleOpenLogOutModal = () => {
    setIsLogOutModalOpen(true);
  };

  const handleChangePasswordModalChange = () => setIsShowChangePasswordModal(!isShowChangePasswordModal);

  const handleLogoutClick = () => {
    dispatch(organizationLogout());
    dispatch(clearEventData());
    dispatch(setNotifications({notifications: [], target: 'unread'}));
    dispatch(setNotifications({notifications: [], target: 'all'}));

    navigate(`/${ROUTER_URL.LOGIN}`);
  };

  const actionCards = [
    {id: 'profile', label: 'Profile', icon: <TicketIcon />, action: handleProfileClick},
    {
      id: 'notifications',
      label: 'Notifications Settings',
      icon: (
        <Box sx={{rotate: '-90deg'}}>
          <ImportIcon />
        </Box>
      ),
      action: handleNotificationClick,
    },
    {id: 'billing', label: 'Billing', icon: <TicketIcon />, action: handleBillingClick},
    {id: 'change-password', label: 'Change Password', icon: <MoneyIcon />, action: handleChangePasswordModalChange},
    {
      id: 'log-out',
      label: 'Log Out',
      icon: (
        <Box sx={{rotate: '-90deg'}}>
          <ImportIcon />
        </Box>
      ),
      action: handleOpenLogOutModal,
    },
  ];

  return (
    <Box>
      <Box sx={accauntSettingsStyle.wrapper}>
        {actionCards.map((card) => (
          <Box key={card.id} sx={accauntSettingsStyle.card} onClick={card.action}>
            <Box sx={accauntSettingsStyle.textWrapper}>
              <Box sx={accauntSettingsStyle.icon}>{card.icon}</Box>
              <Typography sx={accauntSettingsStyle.text}>{card.label}</Typography>
            </Box>
            <Box sx={accauntSettingsStyle.arrow}>
              <ArrowRightIcon />
            </Box>
          </Box>
        ))}
      </Box>
      <Modal
        open={isLogOutModalOpen}
        onClose={() => setIsLogOutModalOpen(false)}
        onSave={handleLogoutClick}
        title="Log Out"
        description="Are you sure you want to log out?"
        closeButtonTitle="Cancel"
        mainButtonTitle="Log Out"
        mainIcon={<WarningIcon />}
        isShowCloseButton
        isShowSaveButton
        color="error"
        sx={accauntSettingsStyle.modal}
      />
      <Modal onClose={handleChangePasswordModalChange} open={isShowChangePasswordModal} sx={accauntSettingsStyle.modal}>
        <ConfirmationModal onCloseModal={handleChangePasswordModalChange} apiInstance={apiInstance} />
      </Modal>
    </Box>
  );
};

export default AccountSettings;
